import '../styles/main.scss'
import React from 'react'
import { createRoot } from 'react-dom/client'
import initFancybox from "./utils/fancybox" // NB! Impordime funktsiooni
import Accordion from './components/accordion'
import BasicModal from './components/basicModal'
import Slider from './components/slider'
import Base from './components/base'

import AOS from 'aos'
import 'aos/dist/aos.css'

document.addEventListener('DOMContentLoaded', () => {
    // Kutsume Fancyboxi algatuse välja
    initFancybox();
    AOS.init();

    /*
    Base
     */
    const base = document.querySelector('.base');
    if (base) {
        createRoot(base).render(<Base items="Just a demo content for base React component. In case I forget how React works :D"/>);
    }

    /*
        Slider
     */
    const slider = document.querySelector('.slider');
    if (slider) {
        createRoot(slider).render(<Slider items={sliderData}/>);
    }

    /*
    * Accordion
    * */
    const accordion = document.querySelector('.accordion');
    if (accordion) {
        createRoot(accordion).render(<Accordion items={repeaterData}/>);
    }

    const tabs = document.querySelector('.repeater-tabs');
    if (tabs) {
        createRoot(tabs).render(<VerticalTabs items={repeaterData}/>);
    }

    /*
    Modal
     */
    const modal = document.querySelector('.modal');
    if (modal) {
        createRoot(modal).render(<BasicModal items={modalData}/>);
    }


    /* Konkursi vormi dünaamiline haldus ja valideerimine */
    const form = document.getElementById('konkurss_form');
    const rowsContainer = document.getElementById('photo_rows_container');
    const addBtnContainer = document.getElementById('add_photo_button_container');
    const addBtn = document.getElementById('add_photo_btn');
    const MAX_ROWS = 5;

    if (form) {
        const emailInput = document.getElementById('email');
        const emailConfirmInput = document.getElementById('email_confirm');
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Üksiku välja veateate ja oleku kontroll
        function validateField(input) {
            // Otsime lähimat sobivat konteinerit
            const container = input.closest('.form-control-group') || input.closest('div');
            if (!container) return;

            const errorSpan = container.querySelector('.error-message');
            if (!errorSpan) return;

            if (!input.checkValidity()) {
                errorSpan.classList.remove('hidden');
            } else {
                errorSpan.classList.add('hidden');
            }
        }

        // E-posti formaadi ja kattuvuse kontroll
        function validateEmails() {
            if (emailInput && emailInput.value && !emailRegex.test(emailInput.value)) {
                emailInput.setCustomValidity('Vigane e-posti formaat');
            } else if (emailInput) {
                emailInput.setCustomValidity('');
            }

            if (emailConfirmInput && emailConfirmInput.value) {
                if (!emailRegex.test(emailConfirmInput.value)) {
                    emailConfirmInput.setCustomValidity('Vigane e-posti formaat');
                } else if (emailInput && emailInput.value !== emailConfirmInput.value) {
                    emailConfirmInput.setCustomValidity('E-posti aadressid ei kattu.');
                } else {
                    emailConfirmInput.setCustomValidity('');
                }
            }
        }

        // Sündmuste sidumine sisendväljaga (sh checkboxid)
        function bindInputEvents(input) {
            input.addEventListener('blur', () => {
                input.classList.add('touched');
                if (input === emailInput || input === emailConfirmInput) {
                    validateEmails();
                }
                validateField(input);
            });

            input.addEventListener('input', () => {
                if (form.classList.contains('submitted') || input.classList.contains('touched')) {
                    if (input === emailInput || input === emailConfirmInput) {
                        validateEmails();
                        validateField(emailInput);
                        validateField(emailConfirmInput);
                    } else {
                        validateField(input);
                    }
                }
            });

            // Checkboxide jaoks (et reageeriks kohe klõpsamisel)
            if (input.type === 'checkbox') {
                input.addEventListener('change', () => {
                    input.classList.add('touched');
                    validateField(input);
                });
            }
        }

        // Seome esialgsed vormiväljad
        form.querySelectorAll('input').forEach(bindInputEvents);

        // Pildi picker'i ja eelvaate seadistamine
        function setupImagePicker(row) {
            const pickerBox = row.querySelector('.image-picker-box');
            const fileInput = row.querySelector('.photo-file-input');
            const previewImg = row.querySelector('.image-preview');
            const placeholderIcon = row.querySelector('.placeholder-icon');

            if (pickerBox && fileInput) {
                pickerBox.addEventListener('click', () => fileInput.click());

                fileInput.addEventListener('change', function () {
                    if (this.files && this.files[0]) {
                        const reader = new FileReader();
                        reader.onload = function (e) {
                            previewImg.src = e.target.result;
                            previewImg.classList.remove('hidden');
                            placeholderIcon.classList.add('hidden');
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                    fileInput.classList.add('touched');
                    validateField(fileInput);
                });
            }
        }

        // Seadistame esimese rea
        const firstRow = rowsContainer ? rowsContainer.querySelector('.photo-row') : null;
        if (firstRow) {
            setupImagePicker(firstRow);

            const clearBtn = firstRow.querySelector('.clear-row-btn');
            if (clearBtn) {
                clearBtn.addEventListener('click', function () {
                    const fileInput = firstRow.querySelector('.photo-file-input');
                    const titleInput = firstRow.querySelector('input[type="text"]');
                    const previewImg = firstRow.querySelector('.image-preview');
                    const placeholderIcon = firstRow.querySelector('.placeholder-icon');

                    if (fileInput) fileInput.value = '';
                    if (titleInput) titleInput.value = '';
                    if (previewImg) {
                        previewImg.src = '';
                        previewImg.classList.add('hidden');
                    }
                    if (placeholderIcon) placeholderIcon.classList.remove('hidden');

                    if (form.classList.contains('submitted')) {
                        if (fileInput) validateField(fileInput);
                        if (titleInput) validateField(titleInput);
                    }
                });
            }
        }

        // Nupu "Lisa veel üks foto" vajutus
        if (addBtn && rowsContainer) {
            addBtn.addEventListener('click', function () {
                const currentRows = rowsContainer.querySelectorAll('.photo-row');
                if (currentRows.length >= MAX_ROWS) return;

                const rowIndex = currentRows.length;

                const newRow = document.createElement('div');
                newRow.className = 'photo-row border border-[#E5E7EB] rounded-[7.5px] p-3 flex items-center gap-4 bg-white relative';
                newRow.setAttribute('data-row-index', rowIndex);

                newRow.innerHTML = `
                    <div class="relative w-[96px] h-[96px] flex-shrink-0 bg-[#F3F4F6] border border-[#E5E7EB] rounded-[8px] flex flex-col items-center justify-center overflow-hidden cursor-pointer image-picker-box">
                        <label for="photo_file_${rowIndex}" class="sr-only">Vali foto ${rowIndex + 1}</label>
                        <input type="file" id="photo_file_${rowIndex}" name="photos[${rowIndex}][file]" accept="image/jpeg,image/png,image/webp,image/avif,image/heic,image/tiff" class="hidden photo-file-input" required aria-required="true">
                        <div class="placeholder-icon flex flex-col items-center">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 15L14.914 11.914C14.5389 11.539 14.0303 11.328 13.5 11.328C12.9697 11.328 12.4611 11.539 12.086 11.914L3 21M2 3H16C17.1046 3 18 3.89543 18 5V19C18 20.1046 17.1046 21 16 21H2C0.89543 21 0 20.1046 0 19V5C0 3.89543 0.89543 3 2 3ZM8 9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9C4 7.89543 4.89543 7 6 7C7.10457 7 8 7.89543 8 9Z" stroke="#BEBEBE" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <img src="" class="image-preview w-full h-full object-cover hidden" alt="Valitud pildi eelvaade">
                    </div>

                    <div class="flex-grow">
                        <label for="photo_title_${rowIndex}" class="block font-bold text-[14px] leading-[140%] mb-1 text-[#111111]">
                            Foto pealkiri <span class="text-[#FC5656]" aria-hidden="true">*</span>
                        </label>
                        <input type="text" id="photo_title_${rowIndex}" name="photos[${rowIndex}][title]" placeholder="Sisesta foto pealkiri" required aria-required="true" aria-describedby="photo_${rowIndex}_error"
                               class="w-full h-12 px-4 bg-[#F9FAFB] border border-[#E5E7EB] rounded-[7.5px] outline-none text-[#111111] placeholder-[#808080] transition-all focus:border-[#0030DE] focus:shadow-[0_0_8px_rgba(0,48,222,0.2)] invalid:[.submitted_&]:border-[#FC5656] [.touched_&]:invalid:border-[#FC5656]">
                        <span id="photo_${rowIndex}_error" aria-live="polite" class="error-message text-[#FC5656] text-xs mt-1 hidden font-medium block">Palun vali pilt ja sisesta pealkiri.</span>
                    </div>

                    <button type="button" aria-label="Eemalda rida ${rowIndex + 1}" class="remove-row-btn w-5 h-5 rounded-full bg-[#FC5656] text-white flex items-center justify-center font-bold text-xs hover:bg-red-700 transition-colors flex-shrink-0 self-center focus:outline-none focus:ring-2 focus:ring-red-400">
                        ✕
                    </button>
                `;

                rowsContainer.appendChild(newRow);
                setupImagePicker(newRow);

                // Bindime uued sisendid
                newRow.querySelectorAll('input').forEach(bindInputEvents);

                // Eemaldamise loogika
                newRow.querySelector('.remove-row-btn').addEventListener('click', function () {
                    newRow.remove();
                    updateAddButtonVisibility();
                });

                updateAddButtonVisibility();
            });
        }

        function updateAddButtonVisibility() {
            if (!rowsContainer || !addBtnContainer) return;
            const totalRows = rowsContainer.querySelectorAll('.photo-row').length;
            if (totalRows >= MAX_ROWS) {
                addBtnContainer.classList.add('hidden');
            } else {
                addBtnContainer.classList.remove('hidden');
            }
        }

        // Vormi esitamine
        form.addEventListener('submit', function (e) {
            validateEmails();

            if (!form.checkValidity()) {
                e.preventDefault();
                form.classList.add('submitted');

                // Kontrolli kõiki välju
                form.querySelectorAll('input').forEach(input => {
                    validateField(input);
                });

                const firstInvalid = form.querySelector(':invalid');
                if (firstInvalid) {
                    firstInvalid.focus();
                }
            }
        });
    }


});